import { firestore } from "@/firebase";
import { Checker } from "@/lib/Checker";
export class DataObject {
  data = {};
  _validator;
  path = "";
  _firestore = firestore;

  /**
   * @param {{data:object, path:string, validator:function} args
   */
  constructor({ validator, path, data }) {
    Checker.checkTypes(data, ["object"]);
    Checker.checkTypes(path, ["string"]);
    Checker.checkTypes(validator, ["function"]);
    this._validator = validator;
    this._validator(data);
    this.data = data;
    this.path = path;
  }

  updateData(data) {
    let result = { ...this.data, ...data };
    this._validator(result);
    this.data = result;
  }

  async save() {
    this._validator(this.data);
    await this._firestore.doc(this.path).set(this.data);
  }

  async remove() {
    await this._firestore.doc(this.path).delete();
  }

  setFirestore(firestore) {
    this._firestore = firestore;
  }

  getFirestore() {
    return this._firestore;
  }
}
